module.exports = __webpack_public_path__ + "media/images/costumes/top/dress/thumbnail-1-fa312c1f572ae4a8fc334ef9ff80adc5.jpg";